export default "/images/vendor/flag-icons/flags/1x1/iq.svg?9303cd0b9b67cfb598bc8dcd014f4afa";